/**
 * All the color of chains supported by Debank.
 */

const CHAIN_COLORS = {
  arb: '#3290ED',
  avax: '#77B5F2',
  eth: '#9D53F2',
  bsc: '#82ca9d',
  ftm: '#3290ED',
  matic: '#EE7C11',
  op: '#F71B0C',
  canto: '#432C7A',
  nova: '#E97777',
  swm: '#80489C',
  tlos: '#FF9F9F',
  dfk: '#FF8FB1',
  evmos: '#432C7A',
  sgb: '#E97777',
  kcc: '#80489C',
  wan: '#FF9F9F',
  rsk: '#FF8FB1',
  iotx: '#FCE2DB',
  palm: '#8D9EFF',
  sdn: '#6B728E',
  astar: '#50577A',
  klay: '#829460',
  hmy: '#432C7A',
  fuse: '#E97777',
  sbch: '#80489C',
  mobm: '#FF9F9F',
  aurora: '#FF8FB1',
  btt: '#FCE2DB',
  metis: '#8D9EFF',
  boba: '#6B728E',
  cro: '#50577A',
  movr: '#829460',
  celo: '#FFE1E1',
  heco: '#FD841F',
  okt: '#624F82',
  xdai: '#FFDDD2',
  spot: '#a17fc0', // exchange balance type
  future: '#008080', // exchange balance type
  margin: '#008080', // exchange balance type
};

export { CHAIN_COLORS };
